const AllowedFileTypes = import.meta.env.VITE_APP_ATTACHMENT_ALLOWED_FILE_TYPES.split(',');
const AllowedExtensions = import.meta.env.VITE_APP_ATTACHMENT_ALLOWED_EXTENSIONS.split(',');

export const isValidFileType = (file: File): boolean => {
  const fileExtension = '.' + file.name.split('.').pop()?.toLowerCase();
  return AllowedFileTypes.includes(file.type) || AllowedExtensions.includes(fileExtension);
};

export const fileToBase64 = async (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const dataUrl = reader.result as string;
      const base64Data = dataUrl.split(',')[1]; // Remove "data:image/jpeg;base64," prefix
      resolve(base64Data);
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
};

export const extractFilenameFromAttachmentUrl = (url: URL): string => {
  const urlString = url.toString();
  const segments = urlString.split('/');
  const lastSegment = segments[segments.length - 1];
  const fileName = lastSegment.split('?')[0];
  return decodeURIComponent(fileName);
};
